import { Form, Modal } from "antd";
import React from "react";
import { CreateEmissionDto } from "../../../api";
import { EmissionColumns } from "../form/columns";

interface EmissionFormProps {
  visible: boolean;
  setVisible: Function;
  onCreateEmission: (values: CreateEmissionDto) => void;
}

export const EmissionForm: React.FC<EmissionFormProps> = ({ visible, setVisible, onCreateEmission }) => {
  const [form] = Form.useForm<CreateEmissionDto>();

  return (
    <Modal open={visible} onOk={form.submit} okText="Создать" cancelText="Отмена" onCancel={() => setVisible(false)}>
      <Form form={form} className="p-8" layout="vertical" onFinish={onCreateEmission}>
        {EmissionColumns().map(({ title, key, rules, inputNode, hideOnForm }, index) => (
          <>
            {!hideOnForm && <Form.Item label={title} name={key} rules={rules} key={index}>
              {inputNode}
            </Form.Item>}
          </>
        ))}
      </Form>
    </Modal>
  );
};
